module.exports = __webpack_public_path__ + "static/media/youtube.2f027ba9.svg";